import { RechazosTracesNavMenuItemViewModel } from '../../../_importacion/buscadores/rechazostraces/rechazostraces.types';

export class NavMenuServiceRechazosTraces {
    protected _currentRechazoTraces: RechazosTracesNavMenuItemViewModel | undefined;

    protected refresh(): void {
        // TO BE OVERRIDEN IN THE PARENT
    }

    protected resetRechazoTracesData(): void {
        this._currentRechazoTraces = new RechazosTracesNavMenuItemViewModel();
    }

    protected set currentRechazoTraces(value: RechazosTracesNavMenuItemViewModel) {
        this._currentRechazoTraces = value;
        this.refresh();
    }

    protected get currentRechazoTraces(): RechazosTracesNavMenuItemViewModel {
        if (!this._currentRechazoTraces) {
            this._currentRechazoTraces = new RechazosTracesNavMenuItemViewModel();
        }
        return this._currentRechazoTraces;
    }

    public updateMenuServiceForRechazoTraces(CHEDPP: string): void {
        const vm = new RechazosTracesNavMenuItemViewModel();
        vm.CHEDPP = CHEDPP;
        this.currentRechazoTraces = { ...vm };
    }

    public clearMenuServiceForRechazoTraces(): void {
        const vm = new RechazosTracesNavMenuItemViewModel();
        vm.CHEDPP = '';
        this.currentRechazoTraces = { ...vm };
    }

    protected get isRechazoTracesSelected(): boolean {
        if (this.currentRechazoTraces !== undefined && this.currentRechazoTraces !== null) {
            return this.currentRechazoTraces.CHEDPP !== undefined && this.currentRechazoTraces.CHEDPP !== null && this.currentRechazoTraces.CHEDPP !== '';
        } else return false;
    }
}
